var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collection-links__wrapper",
      class: _vm.schema.sectionBgColor,
      style: _vm.wrapperStyle
    },
    [
      _c("div", { staticClass: "collection-links__container container" }, [
        _c(
          "h3",
          {
            staticClass: "collection-links__heading",
            class: _vm.schema.sectionTitleColor
          },
          [_vm._v(_vm._s(_vm.schema.sectionTitle))]
        ),
        _c("div", { staticClass: "collection-links__links-section" }, [
          _vm.largeLink
            ? _c(
                "a",
                {
                  staticClass: "collection-links__large-link",
                  style: _vm.largeLinkStyle,
                  attrs: { href: _vm.largeLink.settings.linkUrl }
                },
                [
                  _c(
                    "h6",
                    { staticClass: "collection-links__large-link-heading" },
                    [_vm._v(_vm._s(_vm.largeLink.settings.heading))]
                  ),
                  _c(
                    "p",
                    { staticClass: "collection-links__large-link-copy" },
                    [_vm._v(_vm._s(_vm.largeLink.settings.bodyCopy))]
                  ),
                  _c(
                    "v-link",
                    {
                      staticClass: "collection-links__large-link-anchor",
                      attrs: {
                        primary: true,
                        href: _vm.largeLink.settings.linkUrl
                      }
                    },
                    [_vm._v(_vm._s(_vm.largeLink.settings.linkText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "collection-links__link-wrapper" },
            _vm._l(_vm.smallLinks, function(link) {
              return _c(
                "div",
                {
                  key: link.id,
                  staticClass: "collection-links__link-container"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "collection-links__link",
                      attrs: { href: link.settings.linkUrl }
                    },
                    [
                      _c("span", { staticClass: "strong-bold body-md-sm" }, [
                        _vm._v(_vm._s(link.settings.linkTitle))
                      ]),
                      _c("icon", {
                        staticClass: "icon",
                        attrs: { name: "arrow-right", size: "24px" }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }